import { render } from "./Asset.vue?vue&type=template&id=6323fd38&scoped=true"
import script from "./Asset.vue?vue&type=script&lang=js"
export * from "./Asset.vue?vue&type=script&lang=js"

import "./Asset.vue?vue&type=style&index=0&id=6323fd38&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6323fd38"]])

export default __exports__